import { ValidationError } from 'yup';

export interface Errors{
	[key: string]: string;
}

export default function getValidationErrors(err: ValidationError): Errors {
	const validationErrors: Errors = {};

	const inner = err.inner;
	if (Array.isArray(inner) && inner.length > 0) {
		inner.forEach((error) => {
			if (error.path) {
				validationErrors[error.path] = error.message;
			}
		});
	} else if (err.path) {
		validationErrors[err.path] = err.message;
	}

	return validationErrors;
}